// extracted by mini-css-extract-plugin
export var phone = "_1a-0";
export var phoneDragging = "_1a-1";